export const players = [
  {
    number: 1,
    name: "Allison",
    position: "GK"
  },
  {
    number: 7,
    name: "James Milner",
    position: "DF"
  },
  {
    number: 32,
    name: "Joel Matip",
    position: "DF"
  },
  {
    number: 4,
    name: "Virgil Van Dijk",
    position: "DF"
  },
  {
    number: 26,
    name: "Andrew Robertson",
    position: "DF"
  },
  {
    number: 14,
    name: "Jordan Henderson",
    position: "MD"
  },
  {
    number: 4,
    name: "Fabingo",
    position: "MD"
  },
  {
    number: 17,
    name: "Curtis Jones",
    position: "MD"
  },
  {
    number: 11,
    name: "Mohammed Salah",
    position: "FD"
  },
  {
    number: 20,
    name: "Diogo Jota",
    position: "FD"
  },
  {
    number: 10,
    name: "Sadio Mane",
    position: "FD"
  },
];

export const substitutes = [
  {
    number: 62,
    name: "Caoimhin Kelleher",
    position: "GK"
  },
  {
    number: 5,
    name: "Ibrahima Konate",
    position: "DF"
  },
  {
    number: 22,
    name: "Devor Origi",
    position: "FD"
  },
  {
    number: 28,
    name: "Neco Williams",
    position: "DF"
  },
  {
    number: 40,
    name: "Alex Chamberin",
    position: "DF"
  },
  {
    number:  52,
    name: "Roberto Firmino",
    position: "MD"
  },
];

export const coach = "Jurgen Klopp";